export default __webpack_public_path__ + "static/media/ic_add_to_queue.6fc359ad.svg";